module.exports = __webpack_public_path__ + "restrictions-icon-sm.png?a3d2d3957f0fffc2a4fd84a4228b3bce";